/**
 * Known module types (convenience constant for feature-gating logic).
 * New modules are added via DB migrations in the module_definitions table —
 * this constant only needs to include modules referenced in code for
 * specific feature logic (e.g., showing Rebates tabs).
 */
export const MODULE_TYPES = {
  REBATES: "rebates",
  SHIP_AND_DEBIT: "ship-and-debit",
  AR_STATEMENTS: "ar_statements",
} as const;

/**
 * Widened to string so the service layer accepts any DB-defined module name.
 */
export type ModuleType = string;

/**
 * Known entity types (convenience constant).
 */
export const ENTITY_TYPES = {
  AP_SUPPLIER: "ap_supplier",
  COMPANY: "company",
  CUSTOMER: "customer",
} as const;

/**
 * Widened to string so the service layer accepts any entity type.
 */
export type EntityType = string;
